import request from "@/utils/request";
export const fetchBalanceInfo = () => request.get("/asset/balance/info");
export const fetchBalanceLogs = params => request.get("/asset/log/list", {
  params
});
export const rechargeBalance = payload => request.post("/asset/recharge", payload);
export const transferBalance = payload => request.post("/asset/balance/transfer", payload);
export const consumeBalance = payload => request.post("/user/balance/consume", payload);
export const searchProducts = params => request.get("/asset/products/search", {
  params
});
export const updateAdminPassword = payload => request.post("/admin/updatePassword", payload);
export const updateProfileInfo = payload => request.post("/admin/update", payload);